import { render, staticRenderFns } from "./ManageTreeItem.vue?vue&type=template&id=81c2acfa&scoped=true"
import script from "./ManageTreeItem.vue?vue&type=script&lang=js"
export * from "./ManageTreeItem.vue?vue&type=script&lang=js"
import style0 from "./ManageTreeItem.vue?vue&type=style&index=0&id=81c2acfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c2acfa",
  null
  
)

export default component.exports